import { Settings2 } from "lucide-react";
import { useCustomParametersStore } from "../custom-parameters-store";
import { observer } from "mobx-react-lite";

export const NoParameters = observer(() => {
  const store = useCustomParametersStore();
  const { hasParameters, isViewing } = store;

  if (hasParameters) return null;

  if (isViewing)
    return (
      <div className="flex h-36 w-full flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 p-4 text-center shadow-sm">
        <Settings2 className="mb-3 h-8 w-8 text-gray-400" />
        <p className="mb-1 font-medium text-gray-700">
          Your model has no parameters
        </p>
        <p className="max-w-md text-sm text-gray-500">
          Parameters let you customize the behavior of your model.
        </p>
      </div>
    );

  return (
    <div className="flex h-36 w-full flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 p-4 text-center shadow-sm">
      <Settings2 className="mb-3 h-8 w-8 text-gray-400" />
      <p className="mb-1 font-medium text-gray-700">
        No parameters created yet
      </p>
      <p className="max-w-md text-sm text-gray-500">
        Parameters let you customize the behavior of your model. Click the
        button below to start creating parameters.
      </p>
    </div>
  );
});
